import { useParams } from "react-router-dom";
import EmailPreview from "./EmailPreview";
import { useContext } from "react";
import { AuthContext } from "../../services/context";
import { getCurrentWorkspace } from "../../services/userConfig";
import { useGetCampaign } from "../../api/campaigns";
import { useGetEvent } from "../../api/event";
import { Container, Loader, Text } from "@mantine/core";
import { usePageTitle } from "../../services/HeaderTitleContext";

const ViewCampaign = () => {
  const { id } = useParams();
  const { user } = useContext(AuthContext);
  const { eventId } = getCurrentWorkspace(user);

  const { data, isPending, isSuccess, isError, error } = useGetCampaign({
    id,
    eventId,
  });
  const { data: event } = useGetEvent(data?.eventId);

  usePageTitle(data?.subject ? `Preview - ${data?.subject}` : null);

  return (
    <>
      <Container size="xl">
        {isPending && <Loader />}
        {isError && <Text c="red">{error.message}</Text>}
        {isSuccess && (
          <EmailPreview content={data?.content} eventName={event?.name} />
        )}
      </Container>
    </>
  );
};

export default ViewCampaign;
